<template>
<v-container fluid grid-list-md text-xs-center>
    <v-layout row wrap>
      <v-flex xs12 mb-2 v-if="getFiltersChips">
        <Filters v-bind:filters="getFilters"></Filters>
      </v-flex>

      <v-flex xs12>
        <v-card>
          <v-card-text class="pa-0 grey lighten-2 mb-3">
            <Counters v-bind:counters="['users']" v-bind:filters="getFilters"></Counters>
          </v-card-text>
        </v-card>
      </v-flex>

      <v-flex xs6>
        <v-expansion-panel :value=expansionValue>
          <v-expansion-panel-content class="secondary accent--text" expand-icon="fa-angle-down accent--text">
            <div slot="header">
              <div style="float: left;margin-bottom: 0;line-height: 50px">User Contributions</div>
              <v-dialog style="float: right" v-model="usersPolarChartDialog" fullscreen hide-overlay transition="dialog-bottom-transition">
                <v-btn slot="activator" color="primary" class='ml-0 mr-2' style="width:30px" icon flat><v-icon style="font-size: 20px">fas fa-expand</v-icon></v-btn>
                <v-flex white style="height: 100%">
                  <v-toolbar dark color="accent" style="height: 65px">
                    <p class="headline mb-0">User Contributions</p>
                    <v-spacer></v-spacer>
                    <v-btn flat icon color="primary" style="float: right;" class="mx-0" @click.stop="snap($refs['FullUsersPolarChart'], 'FullUsersPolarChart')">
                      <v-icon>get_app</v-icon>
                    </v-btn>
                    <v-btn class='mx-0' icon dark @click.native="usersPolarChartDialog = false">
                      <v-icon>close</v-icon>
                    </v-btn>
                  </v-toolbar>
                  <v-flex id="FullUsersPolarChart" ref="FullUsersPolarChart" style="height: calc(100% - 65px);display:flex;align-items:center;justify-content:center;padding-top:20px" v-if="usersPolarChartDialog">
                    <UsersPolarChart v-bind:options="{}" v-bind:filters="getFilters"></UsersPolarChart>
                  </v-flex>
                </v-flex>
              </v-dialog>
              <v-btn flat icon color="primary" style="float: right; width: 30px" class="mx-0" @click.stop="snap($refs['UsersPolarChart'], 'UsersPolarChart')">
                <v-icon>get_app</v-icon>
              </v-btn>
            </div>
            <v-card style="height: 432px;" class="d-flex justify-center align-center">
              <v-card-text id="UsersPolarChart" ref="UsersPolarChart" style="height: 100%">
                <UsersPolarChart v-bind:options="{}" v-bind:filters="getFilters"></UsersPolarChart>
              </v-card-text>
            </v-card>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-flex>

      <v-flex xs6>
        <v-expansion-panel :value=expansionValue>
          <v-expansion-panel-content class="text-xs-center secondary accent--text" expand-icon="fa-angle-down accent--text">
            <div slot="header">
              <div style="float: left;margin-bottom: 0;line-height: 50px">User Locations</div>
              <v-dialog style="float: right" v-model="usersLocationsPieChartDialog" fullscreen hide-overlay transition="dialog-bottom-transition">
                <v-btn slot="activator" color="primary" class='ml-0 mr-2' style="width:30px" icon flat><v-icon style="font-size: 20px">fas fa-expand</v-icon></v-btn>
                <v-flex white style="height: 100%">
                  <v-toolbar dark color="accent" style="height: 65px">
                    <p class="headline mb-0">User Locations</p>
                    <v-spacer></v-spacer>
                    <v-btn flat icon color="primary" style="float: right;" class="mx-0" @click.stop="snap($refs['FullUsersLocationsPieChart'], 'FullUsersLocationsPieChart')">
                      <v-icon>get_app</v-icon>
                    </v-btn>
                    <v-btn class='mx-0' icon dark @click.native="usersLocationsPieChartDialog = false">
                      <v-icon>close</v-icon>
                    </v-btn>
                  </v-toolbar>
                  <v-flex id="FullUsersLocationsPieChart" ref="FullUsersLocationsPieChart" style="height: calc(100% - 65px);display:flex;align-items:center;justify-content:center" v-if="usersLocationsPieChartDialog">
                    <UsersLocationsPieChart text-xs-center v-bind:options="{}" v-bind:filters="getFilters"></UsersLocationsPieChart>
                  </v-flex>
                </v-flex>
              </v-dialog>
              <v-btn flat icon color="primary" style="float: right; width: 30px" class="mx-0" @click.stop="snap($refs['UsersLocationsPieChart'], 'UsersLocationsPieChart')">
                <v-icon>get_app</v-icon>
              </v-btn>
            </div>
            <v-card style="height: 432px;" class="d-flex justify-center align-center">
              <v-card-text id="UsersLocationsPieChart" ref="UsersLocationsPieChart" style="height: 100%">
                <UsersLocationsPieChart text-xs-center v-bind:options="{}" v-bind:filters="getFilters"></UsersLocationsPieChart>
              </v-card-text>
            </v-card>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-flex>

      <v-flex xs12>
        <v-toolbar class="elevation-1 secondary" >
          <v-toolbar-side-icon><v-icon>fas fa-users</v-icon></v-toolbar-side-icon>
          <v-toolbar-title>Users</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-flex xs2>
            <v-select
              v-model="layout"
              :items="userView"
              hide-details
              item-text="text"
              item-value="value"
              label="View"
              :menu-props="{maxHeight:'900'}">
              <template slot="selection" slot-scope="{ item, tile }">
                <span><v-icon :color="item.color" small class="mr-2">{{ item.icon }}</v-icon>{{ item.text}}</span>
              </template>
              <template slot="item" slot-scope="{ item, tile }"
              >
                <v-list-tile-action>
                  <v-icon :color="item.color">{{ item.icon }}</v-icon>
                </v-list-tile-action>
                <v-list-tile-content>
                  <v-list-tile-title v-text="item.text"></v-list-tile-title>
                </v-list-tile-content>
              </template>
            </v-select>
          </v-flex>
          <v-flex xs3>
            <v-select
              v-model="sortBy"
              :items="userSort"
              hide-details
              item-text="text"
              item-value="value"
              label="Sort By"
              :menu-props="{maxHeight:'900'}">
              <template slot="selection" slot-scope="{ item, tile }">
                <span><v-icon :color="item.color" small class="mr-2">{{ item.icon }}</v-icon>{{ item.text}}</span>
              </template>
              <template slot="item" slot-scope="{ item, tile }"
              >
                <v-list-tile-action>
                  <v-icon :color="item.color">{{ item.icon }}</v-icon>
                </v-list-tile-action>
                <v-list-tile-content>
                  <v-list-tile-title v-text="item.text"></v-list-tile-title>
                </v-list-tile-content>
              </template>
            </v-select>
          </v-flex>
          <v-tooltip bottom>
            <v-avatar slot="activator">
              <v-icon v-bind:class="[orderBy === 'ASC' ? 'ascending' : 'descending']" @click="orderChange">arrow_downward</v-icon>
            </v-avatar>
            <span>Ascending / Descending Order</span>
          </v-tooltip>
        </v-toolbar>
        <v-card>
          <v-card-text class="pa-0">
            <center>
              <UsersListing v-bind:options="{layout: layout, sortBy: sortBy, orderBy: orderBy, sortIcon: sortIcon}" v-bind:filters="getFilters"></UsersListing>
            </center>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<style>
  .ascending {
    transform: rotate(-180deg);
    transition: 0.2s all ease-in-out;
  }
  .descending {
    transform: rotate(0deg);
    transition: 0.2s all ease-in-out;
  }
</style>

<script>
import { mapGetters, mapMutations } from 'vuex'
import { snap } from '@/helpers/snapshots'
import Filters from './Filters.vue'
import Counters from './Counters.vue'
import UsersListing from './listings/UsersListing.vue'
import UsersPolarChart from './charts/UsersPolarChart.vue'
import UsersLocationsPieChart from './charts/UsersLocationsPieChart.vue'

export default {
  data () {
    return {
      expansionValue: 0,
      usersPolarChartDialog: false,
      usersLocationsPieChartDialog: false,
      userView: [
        {color: 'blue lighten-2', icon: 'dashboard', text: 'Grid', value: 'grid'},
        {color: 'purple lighten-2', icon: 'dns', text: 'Tiles', value: 'tiles'}
      ],
      orderBy: 'DESC',
      sortBy: '_followers_count',
      layout: 'grid',
      userSort: [
        {color: 'blue lighten-3', icon: 'fab fa-twitter ', text: 'Tweets', value: '_tweet_count'},
        {color: 'gray lighten-2', icon: 'fas fa-users', text: 'Followers', value: '_followers_count'},
        {color: 'green lighten-2', icon: 'fas fa-retweet', text: 'Retweet', value: '_retweet_count'},
        {color: 'blue lighten-2', icon: 'fas fa-comment', text: 'Reply', value: '_reply_count'},
        {color: 'teal lighten-2', icon: 'fas fa-quote-right', text: 'Quote Tweet', value: '_quote_count'},
        {color: 'orange lighten-2', icon: 'fas fa-calendar', text: 'Date', value: '_created_at'}
      ]
    }
  },
  computed: {
    ...mapGetters('auth', ['isLoggedIn', 'currentUser']),
    ...mapGetters('filters', ['getFilters']),
    ...mapGetters('toggles', ['getFiltersChips']),
    sortIcon: function () {
      for (var x = 0; x < this.userSort.length; x++) {
        if (this.userSort[x].value === this.sortBy) {
          return {color: this.userSort[x].color, icon: this.userSort[x].icon}
        }
      }
    }
  },
  methods: {
    ...mapMutations('notification', ['notify']),
    ...mapMutations('filters', ['setFilters', 'resetFilters']),
    snap,
    orderChange () {
      this.orderBy = this.orderBy === 'DESC' ? 'ASC' : 'DESC'
    }
  },
  components: {
    Filters,
    Counters,
    UsersListing,
    UsersPolarChart,
    UsersLocationsPieChart
  }
}
</script>


// WEBPACK FOOTER //
// src/components/Users.vue